import { render } from "./outboundCallRecords.vue?vue&type=template&id=3a8f074a&scoped=true"
import script from "./outboundCallRecords.vue?vue&type=script&lang=js"
export * from "./outboundCallRecords.vue?vue&type=script&lang=js"

import "./outboundCallRecords.vue?vue&type=style&index=0&id=3a8f074a&scoped=true&lang=css"
import "./outboundCallRecords.vue?vue&type=style&index=1&id=3a8f074a&lang=css"
script.render = render
script.__scopeId = "data-v-3a8f074a"

export default script